const codeReducer = (state, action) => {
  switch (action.type) {
    case 'SET_CODE': {
      return action.payload;
    }
    default:
      return state;
  }
};

const vibrateReducer = (state, action) => {
  switch (action.type) {
    case 'SET_VIBRATE': {
      localStorage.setItem('rfs:vibrate', !state);
      return !state;
    }
    default:
      return state;
  }
};

const wakeLockReducer = (state, action) => {
  switch (action.type) {
    case 'SET_WAKELOCK': {
      localStorage.setItem('rfs:wakeLock', !state);
      return !state;
    }
    default:
      return state;
  }
};

const zoomReducer = (state, action) => {
  switch (action.type) {
    case 'ZOOM_IN': {
      if (state >= 3) return state;
      const value = +(state + 0.1).toFixed(1);
      localStorage.setItem('rfs:zoom', value);
      return value;
    }
    case 'ZOOM_OUT': {
      if (state <= 0.5) return state;
      const value = +(state - 0.1).toFixed(1);
      localStorage.setItem('rfs:zoom', value);
      return value;
    }
    default:
      return state;
  }
};

const swapButtonsReducer = (state, action) => {
  switch (action.type) {
    case 'SET_SWAP_BUTTONS': {
      localStorage.setItem('rfs:swapButtons', !state);
      return !state;
    }
    default:
      return state;
  }
};

export default function controlReducer(state, action) {
  const {
    code, vibrate, wakeLock, zoom, swapButtons,
  } = state;

  return {
    code: codeReducer(code, action),
    vibrate: vibrateReducer(vibrate, action),
    wakeLock: wakeLockReducer(wakeLock, action),
    zoom: zoomReducer(zoom, action),
    swapButtons: swapButtonsReducer(swapButtons, action),
  };
}
